/* 4N6LAB Theme JS */
(function () {
  'use strict';

  /* ─── Currency formatter ─── */
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10);
    var amount = (cents / 100).toFixed(2);
    // Use Shopify's currency symbol from the page meta if available, else $
    var symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active + ' '
      : '$';
    return symbol + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ─── Zero-pad cart count ─── */
  function padCartCount(n) {
    var s = String(n);
    return s.length >= 2 ? s : ('0' + s);
  }

  /* ─── Custom cursor ring ─── */
  ;(function () {
    var ring = document.getElementById('cursor');
    if (!ring || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var raf = null;
    var x = 0, y = 0;
    document.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      if (raf == null) {
        raf = requestAnimationFrame(function () {
          raf = null;
          ring.style.setProperty('--cursor-x', x + 'px');
          ring.style.setProperty('--cursor-y', y + 'px');
        });
      }
    }, { passive: true });

    var hoverSel = 'a, button, [role="button"], .product-card, .ascii-card, .look-cell, .filter-btn, .term-btn, .variant-pill, input[type="submit"], input[type="button"], [data-cursor-hover]';
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest(hoverSel)) ring.classList.add('is-hovering');
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest(hoverSel)) ring.classList.remove('is-hovering');
    });

    /* hide ring when leaving viewport, restore on re-enter */
    document.addEventListener('mouseleave', function () { ring.classList.add('is-hidden'); });
    document.addEventListener('mouseenter', function () { ring.classList.remove('is-hidden'); });

    /* click pulse */
    document.addEventListener('mousedown', function () { ring.classList.add('is-clicking'); });
    document.addEventListener('mouseup',   function () { ring.classList.remove('is-clicking'); });
  })();

  /* ─── Page visible ─── */
  ;(function () {
    var wrap = document.getElementById('page-wrap');
    if (wrap) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          wrap.classList.add('page-visible');
        });
      });
    }
  })();

  /* ─── Page transition ─── */
  ;(function () {
    var overlay = document.getElementById('page-transition');
    if (!overlay) return;
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript') ||
          href.startsWith('mailto') || link.target === '_blank') return;
      e.preventDefault();
      overlay.classList.add('is-entering');
      setTimeout(function () { window.location.href = href; }, 440);
    });
  })();

  /* ─── Nav hover-active ─── */
  ;(function () {
    var navBar = document.getElementById('nav-bar');
    var originalActive = document.querySelector('.nav-tab.active');
    if (!navBar || !originalActive) return;
    navBar.addEventListener('mouseenter', function (e) {
      var target = e.target.closest('.nav-tab');
      if (target) {
        document.querySelectorAll('.nav-tab').forEach(function (tab) {
          tab.classList.remove('active');
        });
        target.classList.add('active');
      }
    });
    navBar.addEventListener('mouseleave', function () {
      document.querySelectorAll('.nav-tab').forEach(function (tab) {
        tab.classList.remove('active');
      });
      originalActive.classList.add('active');
    });
  })();

  /* ─── Menu hover (desktop only — touch devices use click toggle) ─── */
  ;(function () {
    var menuBtn = document.getElementById('menu-btn');
    var navBar = document.getElementById('nav-bar');
    if (!menuBtn || !navBar) return;
    /* Skip hover handlers on devices without a fine pointer (touch screens, etc.) */
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var closeTimer = null;
    function openNav() {
      clearTimeout(closeTimer);
      navBar.classList.add('nav-open');
    }
    function scheduleClose() {
      closeTimer = setTimeout(function () {
        navBar.classList.remove('nav-open');
      }, 350);
    }
    menuBtn.addEventListener('mouseenter', openNav);
    menuBtn.addEventListener('mouseleave', scheduleClose);
    navBar.addEventListener('mouseenter', openNav);
    navBar.addEventListener('mouseleave', scheduleClose);
  })();

  /* ─── Variant selector (product page) ─── */
  document.querySelectorAll('.variant-pills').forEach((group) => {
    group.addEventListener('click', (e) => {
      const pill = e.target.closest('.variant-pill');
      if (!pill) return;
      group.querySelectorAll('.variant-pill').forEach((p) => p.classList.remove('active'));
      pill.classList.add('active');
      // Update hidden master select
      const form = pill.closest('form');
      if (!form) return;
      const optionIndex = parseInt(group.dataset.optionIndex, 10);
      const value = pill.dataset.value;
      form.dataset['option' + optionIndex] = value;
      updateMasterSelect(form);
    });
  });

  function updateMasterSelect(form) {
    const variantsScript = form.querySelector('[data-variants]');
    if (!variantsScript) return;
    const variants = JSON.parse(variantsScript.textContent);
    const selected = [
      form.dataset.option1,
      form.dataset.option2,
      form.dataset.option3,
    ].filter(Boolean);
    const match = variants.find((v) => {
      const opts = [v.option1, v.option2, v.option3].filter(Boolean);
      return opts.length === selected.length && opts.every((o, i) => o === selected[i]);
    });
    if (match) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;
      const priceEl = document.querySelector('[data-product-price]');
      if (priceEl && match.price != null) priceEl.textContent = formatMoney(match.price);
      const submit = form.querySelector('[type="submit"]');
      if (submit) {
        if (match.available) {
          submit.disabled = false;
          submit.textContent = submit.dataset.addLabel || 'Add to Cart';
        } else {
          submit.disabled = true;
          submit.textContent = 'Sold Out';
        }
      }
    }
  }

  /* ─── Thumb gallery ─── */
  document.querySelectorAll('.thumb-row').forEach((row) => {
    row.addEventListener('click', (e) => {
      const t = e.target.closest('img');
      if (!t) return;
      const main = document.querySelector('.product-page__media .main-img img');
      if (main) main.src = t.dataset.full || t.src;
    });
  });

  /* ─── Cart count refresh after add ─── */
  document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (form.dataset.noajax === 'true') return;
      e.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)),
        });
        if (!res.ok) throw new Error('add failed');
        const cart = await fetch('/cart.js').then((r) => r.json());
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = padCartCount(cart.item_count);
        });
        if (submit) {
          const orig = submit.dataset.addLabel || submit.textContent;
          submit.textContent = 'Added ✓';
          submit.classList.add('is-added');
          setTimeout(() => {
            submit.textContent = orig;
            submit.disabled = false;
            submit.classList.remove('is-added');
          }, 1500);
        }
      } catch (err) {
        if (submit) submit.disabled = false;
        form.submit();
      }
    });
  });
})();

/* ─── Header live clock ─── */
(function(){
  function pad(n){ return String(n).padStart(2,'0'); }

  /* Unified clock: single element with both data-clock-date + data-clock-time
     (used in the reconciled Liquid header — shows mm/dd/yyyy  hh:mm  ist) */
  var unified = document.querySelector('[data-clock-date][data-clock-time]');

  /* Separate clock elements (legacy / fallback) */
  var dateEl = unified ? null : document.querySelector('[data-clock-date]');
  var timeEl = unified ? null : document.querySelector('[data-clock-time]');

  /* Static-HTML clock (id="header-clock") */
  var staticEl = document.getElementById('header-clock');

  if (!unified && !dateEl && !timeEl && !staticEl) return;

  function tick(){
    var d = new Date();
    var mm  = pad(d.getMonth()+1);
    var dd  = pad(d.getDate());
    var yyyy = d.getFullYear();
    var hh  = pad(d.getHours());
    var min = pad(d.getMinutes());

    if (unified) {
      unified.textContent = mm + '/' + dd + '/' + yyyy + '\u00a0\u00a0' + hh + ':' + min + '\u00a0\u00a0ist';
    }
    if (dateEl) dateEl.textContent = mm + '/' + dd + '/' + yyyy;
    if (timeEl) timeEl.textContent = hh + ':' + min + '\u00a0ist';
    if (staticEl && staticEl !== unified) {
      staticEl.textContent = mm + '/' + dd + '/' + yyyy + '\u00a0\u00a0' + hh + ':' + min + '\u00a0\u00a0ist';
    }
  }
  tick();
  setInterval(tick, 1000);
})();

/* ─── Light theme — fixed, no toggle ─── */
(function(){
  document.documentElement.setAttribute('data-theme', 'light');
})();

/* ─── Motion intensity toggle ─── */
(function(){
  var KEY = '4n6_motion';
  function apply(m){
    document.documentElement.setAttribute('data-motion', m);
    try { localStorage.setItem(KEY, m); } catch(e){}
  }
  if (!document.documentElement.getAttribute('data-motion')) {
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch(e){}
    apply(stored === 'full' ? 'full' : 'restrained');
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-motion-toggle]');
    if (!btn) return;
    var cur = document.documentElement.getAttribute('data-motion') || 'restrained';
    apply(cur === 'restrained' ? 'full' : 'restrained');
  });
})();

/* ─── Hamburger / nav toggle ─── */
/*  Works for both:
    - Liquid header: [data-nav-burger] toggles [data-mobile-nav] (.is-open)
    - Static HTML:   #menu-btn toggles #nav-bar (.nav-open)              */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-nav-burger], #menu-btn');
    if (!btn) return;
    /* Liquid nav */
    var liquidNav = document.querySelector('[data-mobile-nav]');
    /* Static HTML nav — may be the same element or different */
    var staticNav = document.getElementById('nav-bar');
    var nav = liquidNav || staticNav;
    if (!nav) return;

    var open = btn.classList.toggle('is-open');
    /* Liquid class */
    if (liquidNav) liquidNav.classList.toggle('is-open', open);
    /* Static HTML class */
    if (staticNav) staticNav.classList.toggle('nav-open', open);

    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* Close on outside click */
  document.addEventListener('click', function(e){
    var nav = document.querySelector('[data-mobile-nav], #nav-bar');
    var btn = document.querySelector('[data-nav-burger], #menu-btn');
    if (!nav || !btn) return;
    if (btn.contains(e.target) || nav.contains(e.target)) return;
    nav.classList.remove('is-open', 'nav-open');
    btn.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  });
})();

/* ─── Search panel reveal ─── */
(function(){
  var trigger = document.querySelector('[data-search-trigger]');
  var panel   = document.getElementById('search-panel');
  if (!trigger || !panel) return;
  var input = panel.querySelector('[data-predictive-search-input]');
  var closeBtn = panel.querySelector('[data-search-close]');

  function open(){
    panel.hidden = false;
    /* trigger reflow so the transition applies */
    void panel.offsetHeight;
    panel.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    if (input) setTimeout(function(){ input.focus(); }, 50);
  }
  function close(){
    panel.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    setTimeout(function(){
      if (!panel.classList.contains('is-open')) panel.hidden = true;
    }, 300);
  }
  trigger.addEventListener('click', function(e){
    e.preventDefault();
    if (panel.classList.contains('is-open')) close(); else open();
  });
  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
  });
  /* Outside click */
  document.addEventListener('click', function(e){
    if (!panel.classList.contains('is-open')) return;
    if (panel.contains(e.target) || trigger.contains(e.target)) return;
    close();
  });
})();

/* ─── Predictive search (Dawn-equivalent) ─── */
(function(){
  var inputs = document.querySelectorAll('[data-predictive-search-input]');
  if (!inputs.length) return;
  inputs.forEach(function(inp){
    var dd = document.createElement('div');
    dd.className = 'predictive-search';
    dd.hidden = true;
    inp.parentElement.style.position = 'relative';
    inp.parentElement.appendChild(dd);
    var t = null;
    inp.addEventListener('input', function(){
      clearTimeout(t);
      var q = inp.value.trim();
      if (q.length < 2) { dd.hidden = true; dd.innerHTML = ''; return; }
      t = setTimeout(function(){
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function(r){ return r.json(); })
          .then(function(data){
            var results = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!results.length) {
              dd.innerHTML = '<div class="predictive-search__empty">&gt; no signal // refine query</div>';
            } else {
              dd.innerHTML = results.map(function(p){
                return '<a class="predictive-search__item" href="' + p.url + '">' +
                       '<span class="predictive-search__name">' + p.title + '</span>' +
                       '<span class="predictive-search__price">' + (p.price ? formatMoney(p.price) : '') + '</span>' +
                       '</a>';
              }).join('');
            }
            dd.hidden = false;
          }).catch(function(){
            dd.hidden = true;
          });
      }, 180);
    });
    document.addEventListener('click', function(e){
      if (!inp.parentElement.contains(e.target)) { dd.hidden = true; }
    });
  });
})();

/* ─── Quick-view (Yeezy-style overlay with FLIP image morph) ─── */
(function(){
  var overlay = document.getElementById('quickview');
  if (!overlay) return;
  var media    = overlay.querySelector('[data-quickview-media]');
  var img      = overlay.querySelector('[data-quickview-image]');
  var titleEl  = overlay.querySelector('[data-qv-title]');
  var priceEl  = overlay.querySelector('[data-qv-price]');
  var typeEl   = overlay.querySelector('[data-qv-type]');
  var statusEl = overlay.querySelector('[data-qv-status]');
  var loggedEl = overlay.querySelector('[data-qv-logged]');
  var matEl    = overlay.querySelector('[data-qv-material]');
  var unitsEl  = overlay.querySelector('[data-qv-units]');
  var originEl = overlay.querySelector('[data-qv-origin]');
  var varsEl   = overlay.querySelector('[data-qv-variants]');
  var atcBtn   = overlay.querySelector('[data-qv-atc]');
  var prevBtn  = overlay.querySelector('[data-qv-prev]');
  var nextBtn  = overlay.querySelector('[data-qv-next]');

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cache  = {};
  var currentProduct = null;
  var currentVariant = null;
  var currentImages = [];
  var imgIndex = 0;

  function money(cents){
    var s = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : '';
    return (s ? s + ' ' : '₹') + (cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function optionName(opt){
    if (opt && typeof opt === 'object' && opt.name) return opt.name;
    return String(opt || '');
  }

  function caseIdFor(p){
    var sku = (p.variants && p.variants[0] && p.variants[0].sku) || p.handle || '';
    if (!sku) return 'ts-001';
    return String(sku).toLowerCase();
  }

  function formatDate(iso){
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return '';
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear();
  }

  function setImage(n){
    if (!currentImages.length) return;
    imgIndex = (n + currentImages.length) % currentImages.length;
    var src = currentImages[imgIndex];
    if (src) img.src = src.replace(/(\?|$)/, '?width=1200&');
  }

  function selectVariant(v){
    currentVariant = v;
    priceEl.textContent = money(v.price);
    if (v.available) {
      atcBtn.disabled = false;
      atcBtn.textContent = '[ bag ]';
      atcBtn.setAttribute('aria-label', 'Add to bag');
      if (statusEl) {
        statusEl.textContent = 'active';
        statusEl.classList.remove('spec-table__hot--off');
        statusEl.classList.add('spec-table__hot');
      }
    } else {
      atcBtn.disabled = true;
      atcBtn.textContent = '[ sold out ]';
      atcBtn.setAttribute('aria-label', 'Sold out');
      if (statusEl) {
        statusEl.textContent = 'offline';
        statusEl.classList.add('spec-table__hot--off');
      }
    }
  }

  function renderVariants(p){
    varsEl.innerHTML = '';
    if (!p.options || p.options.length === 0 || p.variants.length <= 1) return;
    p.options.forEach(function(rawOpt, optIdx){
      var optLabel = optionName(rawOpt);
      var wrap = document.createElement('div');
      wrap.className = 'quickview__option';
      var isSize = optLabel.toLowerCase().indexOf('size') !== -1;
      wrap.innerHTML = '<div class="quickview__option-head">' +
        (isSize ? '' : '<label>' + optLabel.toLowerCase() + '</label>') +
        (isSize ? '<button type="button" class="product-form__chart-trigger" data-fit-report-open>size chart</button>' : '') +
        '</div><div class="quickview__pills"></div>';
      var pillsEl = wrap.querySelector('.quickview__pills');
      var values = [];
      p.variants.forEach(function(v){
        var val = v.options[optIdx];
        if (values.indexOf(val) === -1) values.push(val);
      });
      values.forEach(function(val){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'variant-pill';
        b.textContent = val;
        b.dataset.optionIndex = optIdx;
        b.dataset.value = val;
        if (currentVariant && currentVariant.options[optIdx] === val) b.classList.add('active');
        b.addEventListener('click', function(){
          pillsEl.querySelectorAll('.variant-pill').forEach(function(x){ x.classList.remove('active'); });
          b.classList.add('active');
          var sel = [];
          p.options.forEach(function(_, i){
            var active = wrap.parentElement.querySelectorAll('.quickview__option')[i].querySelector('.variant-pill.active');
            sel[i] = active ? active.dataset.value : null;
          });
          /* find variant by matched options */
          var match = p.variants.find(function(v){
            return v.options.every(function(o, i){ return o === sel[i]; });
          });
          if (match) selectVariant(match);
        });
        pillsEl.appendChild(b);
      });
      varsEl.appendChild(wrap);
    });
  }

  /* Track which card image is currently shown (set in open()) so we don't re-fetch */
  var pendingCardImgSrc = null;
  function populate(p){
    currentProduct = p;
    var firstAvail = p.variants.find(function(v){ return v.available; }) || p.variants[0];
    var caseId = caseIdFor(p);
    var title  = (p.title || '').toLowerCase();
    if (titleEl) titleEl.textContent = caseId + ' / ' + title;
    img.alt = p.title;

    if (typeEl)   typeEl.textContent   = (p.type ? '.' + p.type.toLowerCase() + ' / tee' : '.apparel / tee');
    if (loggedEl) loggedEl.textContent = formatDate(p.published_at || p.created_at) || '22.04.2026';
    if (matEl)    matEl.textContent    = '240gsm / 100% cotton';
    if (unitsEl)  unitsEl.textContent  = (firstAvail && firstAvail.inventory_quantity != null) ? (firstAvail.inventory_quantity + ' / 60') : '14 / 60';
    if (originEl) originEl.textContent = 'redacted';

    /* Build gallery */
    currentImages = (p.images && p.images.length) ? p.images.slice() : (p.featured_image ? [p.featured_image] : []);
    imgIndex = 0;
    if (prevBtn && nextBtn) {
      var multi = currentImages.length > 1;
      prevBtn.style.display = multi ? '' : 'none';
      nextBtn.style.display = multi ? '' : 'none';
    }

    /* If open() didn't have a card img to show (e.g. cache miss on product detail page navigation),
       fall back to the product's featured image at the same 1200px resolution as the card. */
    if (!pendingCardImgSrc) {
      var src = currentImages[0] || '';
      if (src) img.src = src.replace(/(\?|$)/, '?width=1200&');
    }
    /* Note: we deliberately DO NOT swap to a higher-res image once the product data arrives.
       The card image is already at 1200px (matches the overlay's max display size on retina)
       so the browser-cached version is reused with zero re-fetch — instant, no flash. */
    pendingCardImgSrc = null;

    selectVariant(firstAvail);
    renderVariants(p);
  }

  function flipAnimate(cardImgRect){
    /* FLIP: the image starts at the clicked card's position+size and travels to the centered
       overlay position+size. Combined with the page scaling OUTWARD from center, this reads
       as "product comes to center, everything else moves away" — the Yeezy effect. */
    media.style.transition = 'none';
    media.style.transform  = '';
    media.style.opacity    = '1';

    /* Measure the natural (target) position */
    var targetRect = media.getBoundingClientRect();
    var dx = (cardImgRect.left + cardImgRect.width  / 2) - (targetRect.left + targetRect.width  / 2);
    var dy = (cardImgRect.top  + cardImgRect.height / 2) - (targetRect.top  + targetRect.height / 2);
    var s  = cardImgRect.width / targetRect.width;

    media.style.transformOrigin = '50% 50%';
    media.style.willChange = 'transform';
    media.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(' + s + ')';

    /* Double-rAF: ensure start frame paints before transition fires */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        media.style.transition = 'transform 0.55s cubic-bezier(0.2, 0.85, 0.25, 1)';
        media.style.transform  = 'translate(0, 0) scale(1)';
      });
    });
  }

  function demoProduct(card){
    /* Build a fake product object from data-demo-* attributes on placeholder cards */
    var name  = card.dataset.demoName  || 'SPECIMEN';
    var sku   = card.dataset.demoSku   || 'TS-000';
    var price = parseInt(card.dataset.demoPrice || '0', 10) * 100;
    var desc  = card.dataset.demoDesc  || '<p>Demo product — import real products in Shopify admin to enable live data.</p>';
    var variants = ['S','M','L','XL'].map(function(s, i){
      return {
        id: -1 * (i + 1),
        title: s,
        options: [s],
        option1: s,
        price: price,
        available: true
      };
    });
    return {
      title: name,
      handle: sku.toLowerCase(),
      description: desc.indexOf('<') === 0 ? desc : '<p>' + desc + '</p>',
      featured_image: '',
      images: [],
      options: ['Size'],
      variants: variants,
      _demo: true
    };
  }

  function open(card){
    var handle = card.dataset.productHandle;
    var isPlaceholder = card.hasAttribute('data-quickview-placeholder');
    if (!handle && !isPlaceholder) return false;

    var cardImg = card.querySelector('.ascii-card__media img') || card.querySelector('.ascii-card__media');
    var rect = cardImg ? cardImg.getBoundingClientRect() : card.getBoundingClientRect();

    /* Show the cached card image in the overlay IMMEDIATELY (before any fetch/populate).
       This eliminates the empty-box flash while the product fetch is in flight. */
    if (cardImg && cardImg.tagName === 'IMG' && !isPlaceholder) {
      img.src = cardImg.src;
      img.alt = cardImg.alt || '';
      pendingCardImgSrc = cardImg.src;
    } else {
      pendingCardImgSrc = null;
    }

    /* Option B Camera Pan: Calculate the translation needed so the clicked card 
       hits the viewport center while the page scales up. */
    var vw = window.innerWidth, vh = window.innerHeight;
    var cx = rect.left + rect.width / 2;
    var cy = rect.top + rect.height / 2;
    var dx = (vw / 2) - cx;
    var dy = (vh / 2) - cy;
    
    document.documentElement.style.setProperty('--anim-page-end', 'translate(' + dx + 'px, ' + dy + 'px) scale(1.6)');

    /* Backdrop spotlight origin: the expanding circle reveal starts AT the clicked card's
       center, so for a split second the backdrop wraps around the item before flooding the
       viewport. */
    var bdX = (cx / vw) * 100;
    var bdY = (cy / vh) * 100;
    document.documentElement.style.setProperty('--backdrop-x', bdX + '%');
    document.documentElement.style.setProperty('--backdrop-y', bdY + '%');

    document.body.classList.add('quickview-open');
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    void overlay.offsetHeight;
    overlay.classList.add('is-open');
    if (!reduce) flipAnimate(rect);

    if (isPlaceholder) {
      populate(demoProduct(card));
      img.removeAttribute('src');
      img.alt = card.dataset.demoName || '';
      media.classList.add('quickview__media--demo');
      media.dataset.label = '[ ' + (card.dataset.demoName || 'NO IMAGE') + ' ]';
      return true;
    }

    media.classList.remove('quickview__media--demo');
    delete media.dataset.label;

    if (cache[handle]) { populate(cache[handle]); return true; }
    fetch('/products/' + handle + '.js')
      .then(function(r){ return r.json(); })
      .then(function(p){ cache[handle] = p; populate(p); })
      .catch(function(){ window.location.href = '/products/' + handle; });
    return true;
  }

  function close(){
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('quickview-open');
    setTimeout(function(){
      if (!overlay.classList.contains('is-open')) {
        overlay.hidden = true;
        media.style.transition = '';
        media.style.transform = '';
        media.style.opacity = '';
      }
    }, 350);
  }

  /* Card click → open quickview (unless modifier key for new-tab, or the [ add to cart ] hover CTA). */
  document.addEventListener('click', function(e){
    var addCta = e.target.closest('[data-card-add]');
    if (addCta) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = addCta.dataset.variantId;
      if (!variantId) return;
      var orig = addCta.textContent;
      addCta.textContent = '[ ... ]';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ id: variantId, quantity: 1 })
      })
      .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent = String(cart.item_count).padStart(2, '0');
        });
        addCta.textContent = '[ added ]';
        setTimeout(function(){ addCta.textContent = orig; }, 1200);
      })
      .catch(function(){
        addCta.textContent = '[ retry ]';
        setTimeout(function(){ addCta.textContent = orig; }, 1200);
      });
      return;
    }
    var card = e.target.closest('[data-quickview], [data-quickview-placeholder]');
    if (!card) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    if (!open(card)) return;
    e.preventDefault();
  });

  /* Close interactions */
  overlay.addEventListener('click', function(e){
    if (e.target.closest('[data-quickview-close]')) close();
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });

  /* ATC from quickview */
  atcBtn.addEventListener('click', function(){
    if (!currentVariant || !currentVariant.available) return;
    /* Demo mode: skip the real cart add — variant ids are negative */
    if (currentProduct && currentProduct._demo) {
      atcBtn.classList.add('is-added');
      atcBtn.textContent = '[ added ]';
      atcBtn.disabled = true;
      setTimeout(function(){
        atcBtn.classList.remove('is-added');
        atcBtn.textContent = '[ bag ]';
        atcBtn.disabled = false;
      }, 1400);
      return;
    }
    atcBtn.disabled = true;
    var body = new URLSearchParams({ id: currentVariant.id, quantity: 1 });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body
    })
    .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
    .then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent = String(cart.item_count).padStart(2, '0');
      });
      atcBtn.classList.add('is-added');
      atcBtn.textContent = '[ added ]';
      setTimeout(function(){
        atcBtn.classList.remove('is-added');
        atcBtn.textContent = '[ bag ]';
        atcBtn.disabled = false;
      }, 1400);
    })
    .catch(function(){
      atcBtn.disabled = false;
      atcBtn.textContent = '[ retry ]';
    });
  });

  /* Gallery prev/next inside quickview */
  if (prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); setImage(imgIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); setImage(imgIndex + 1); });
})();

/* ─── Info page tab switching + hash deep-linking ─── */
(function(){
  var page = document.querySelector('[data-info-page]');
  if (!page) return;
  var tabs   = page.querySelectorAll('[data-info-tab]');
  var panels = page.querySelectorAll('[data-info-panel]');
  if (!tabs.length || !panels.length) return;

  function activate(key){
    var matched = false;
    tabs.forEach(function(t){
      var hit = t.dataset.infoTab === key;
      t.classList.toggle('is-active', hit);
      if (hit) matched = true;
    });
    panels.forEach(function(p){
      p.classList.toggle('is-active', p.dataset.infoPanel === key);
    });
    return matched;
  }

  /* Init from URL hash (e.g. /pages/info#contact). Strip leading "#" and any sub-anchor (#contact-channels → "contact"). */
  function fromHash(){
    var h = (location.hash || '').replace(/^#/, '');
    if (!h) return false;
    /* Try full hash first (e.g. "contact"), then first segment if hyphenated. */
    if (activate(h)) return true;
    var first = h.split('-')[0];
    return activate(first);
  }

  if (!fromHash()) activate('privacy');

  /* Tab clicks update hash + activate panel */
  tabs.forEach(function(t){
    t.addEventListener('click', function(e){
      e.preventDefault();
      var key = t.dataset.infoTab;
      activate(key);
      history.replaceState(null, '', '#' + key);
    });
  });

  /* React to hash changes (e.g. footer link click) */
  window.addEventListener('hashchange', fromHash);

  /* In-panel sub-section scroll: any link to "#section-id" inside the page scrolls smoothly */
  page.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = page.querySelector('#' + CSS.escape(id));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* In-panel search: filter info-sections by text match in the active panel */
  page.addEventListener('input', function(e){
    var input = e.target.closest('.info-panel__search-input');
    if (!input) return;
    var panel = input.closest('.info-panel');
    if (!panel) return;
    var q = input.value.toLowerCase().trim();
    var anyMatch = false;
    panel.querySelectorAll('.info-section').forEach(function(sec){
      var text = sec.textContent.toLowerCase();
      var hit  = q === '' || text.indexOf(q) !== -1;
      sec.style.display = hit ? '' : 'none';
      if (hit) anyMatch = true;
    });
    /* Also filter pills (anchor pills above sections) to dim non-matching ones */
    panel.querySelectorAll('.info-pill').forEach(function(p){
      var t = p.textContent.toLowerCase();
      p.style.opacity = (q === '' || t.indexOf(q) !== -1) ? '' : '0.25';
    });
    /* Show empty-state if no matches */
    var empty = panel.querySelector('.info-panel__empty');
    if (!empty) {
      empty = document.createElement('div');
      empty.className = 'info-panel__empty';
      empty.textContent = '> no records found';
      panel.querySelector('.info-sections').appendChild(empty);
    }
    empty.style.display = (q !== '' && !anyMatch) ? 'block' : 'none';
  });
})();

/* ─── Fit-report (size chart) panel ─── */
(function(){
  var panel = document.getElementById('fit-report');
  if (!panel) return;
  function open(){
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close(){
    panel.hidden = true;
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function(e){
    var openBtn = e.target.closest('[data-fit-report-open]');
    if (openBtn) { e.preventDefault(); open(); return; }
    var closeBtn = e.target.closest('[data-fit-report-close]');
    if (closeBtn) { e.preventDefault(); close(); return; }
    var tab = e.target.closest('[data-fit-tab]');
    if (tab) {
      var key = tab.dataset.fitTab;
      panel.querySelectorAll('[data-fit-tab]').forEach(function(t){
        var active = t.dataset.fitTab === key;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panel.querySelectorAll('[data-fit-panel]').forEach(function(p){
        var match = p.dataset.fitPanel === key;
        p.classList.toggle('is-active', match);
        p.hidden = !match;
      });
    }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && !panel.hidden) close();
  });
})();
